export enum enumDocumentType {
    'ID' = 'ID',
    'PT' = 'PT',
  }